/**
 * Resolution order for an extracted field's highlight color:
 *
 *   1. per-document override (operator's quick recolor on this container only)
 *   2. the field's own color from its OCR template custom field
 *   3. the `ocr_default_highlight_color` app setting
 *
 * Used by the field cards, the viewer chunk overlays, and — through the chunk
 * colors handed to the viewer — the "download with highlights" PDF export, so
 * all three always agree.
 */
export function resolveFieldHighlightColor(
  override: string | null | undefined,
  templateColor: string | null | undefined,
  defaultColor: string
): string {
  return override ?? templateColor ?? defaultColor;
}
